import { Routes } from '@app/constants/routes';
import { useTypedNavigate } from '@app/router';
import { useQueryParams, withDefault, createEnumParam } from 'use-query-params';

export enum EQRCodeStep {
  TYPE = 'TYPE',
  INPUT = 'INPUT',
  BULK = 'BULK',
  CUSTOMIZE = 'CUSTOMIZE',
  DONE = 'DONE',
}

export enum ESettingsTab {
  CURRENT = 'CURRENT',
  GLOBAL = 'GLOBAL',
}

export const QR_CODE_NAVIGATION_QUERY_PARAM = 'step';
export const SETTINGS_TAB_QUERY_PARAM = 'settingsTab';

const StepEnumParam = createEnumParam(Object.values(EQRCodeStep));
const SettingsTabEnumParam = createEnumParam(Object.values(ESettingsTab));

export const useQRCodeNavigation = () => {
  const navigate = useTypedNavigate();
  const [{ [QR_CODE_NAVIGATION_QUERY_PARAM]: step, [SETTINGS_TAB_QUERY_PARAM]: settingsTab }, setQueryParams] =
    useQueryParams({
      [QR_CODE_NAVIGATION_QUERY_PARAM]: withDefault(StepEnumParam, EQRCodeStep.TYPE),
      [SETTINGS_TAB_QUERY_PARAM]: withDefault(SettingsTabEnumParam, null),
    });

  const handleNavigate = (qrCodeId: string, action: EQRCodeStep, tab?: ESettingsTab) => {
    const queryParams: Record<string, string> = {
      [QR_CODE_NAVIGATION_QUERY_PARAM]: action,
    };
    if (action === EQRCodeStep.INPUT && tab) {
      queryParams[SETTINGS_TAB_QUERY_PARAM] = tab;
    }

    navigate({
      to: Routes.customer.my_qr_codes.edit,
      queryParams,
      params: { id: qrCodeId },
    });
  };

  const getNavigationUrl = (qrCodeId: string, action: EQRCodeStep, tab?: ESettingsTab) => {
    const url = new URL(Routes.customer.my_qr_codes.edit, window.location.origin);
    url.searchParams.set(QR_CODE_NAVIGATION_QUERY_PARAM, action);
    if (action === EQRCodeStep.INPUT && tab) {
      url.searchParams.set(SETTINGS_TAB_QUERY_PARAM, tab);
    }
    url.pathname = url.pathname.replace(':id', qrCodeId);
    return url.pathname + url.search;
  };

  return { step, settingsTab, setQueryParams, handleNavigate, getNavigationUrl };
};
